import { Pipe, PipeTransform } from '@angular/core';

/**
 *  How to Use
 *
 *  Input:  {{'+19099088613' | telephone:'format'}}
 *  Output: (909) 908-8613
 *
 *  Input:  {{'(909) 908-8613' | telephone:'clean'}}
 *  Output: 9099088613
 */

@Pipe({
    name: 'telephone',
    standalone: false
})
export class TelephonePipe implements PipeTransform {

  transform(tel: string, method = 'format'): string {
    const maxLength = 10;

    if (!tel) {
      return '';
    }

    // First check - does it start with +1 or have country code 1?
    const hasCountryCode = tel.startsWith('+1') || (tel.replace(/\D/g, '').length === 11 && tel.replace(/\D/g, '').charAt(0) === '1');

    // Remove all non-digits and +1 prefix
    let value = this.standardizeNumber(tel);

    // If it has country code and is 11 digits, strip the 1
    if (hasCountryCode && value.length === 11 && value.charAt(0) === '1') {
      value = value.substring(1);
    }

    // If not exactly 10 digits after processing, return original
    if (value.length !== maxLength) {
      return tel;
    }

    return method === 'clean'
            ? value
            : this.formatPhoneNumber(value, '');
  }

  standardizeNumber(telephone: string) {
    return telephone.toString().replace('+1', '').trim().replace(/\D/g, '');
  }

  formatPhoneNumber(value, longDistanceCode) {
    const cityCodeLength = 3;
    const numberLength = 7;

    if (value.length > cityCodeLength) {
      const city = value.slice(0, cityCodeLength);
      let number = value.slice(cityCodeLength);

      if (number.length > cityCodeLength) {
        number = `${number.slice(0, cityCodeLength)  }-${  number.slice(cityCodeLength, numberLength)}`;
      }

      return `${longDistanceCode} (${city}) ${number}`.trim();
    }
  }

}
